<template>

  <div class="polyline">
    <l-polyline ref="element"
                :lat-lngs="latlngs"
                :color="color"
                :bubblingMouseEvents="false"
                :editable="editable"
                :options="{ editable: true }"
                @contextmenu="contextmenu($event)"
                @click="click($event)">
    ></l-polyline>
  </div>

</template>

<script>

import { LPolyline } from 'vue2-leaflet'
import { MapService } from '../../services/map.service.es6'
import ElementDialog from '../../dialogs/element-dialog'

export default {
  name: 'map-polyline',

  props: [ 'element', 'active' ],
  data () {
    return {
      editable: false,
      menu: [
        { title: this.$t('map.element.properties'), icon: 'tools', action: () => this.edit() },
        { title: this.$t('map.element.edit'), icon: 'pen', action: () => this.editable = true },
        { title: this.$t('map.element.remove'), icon: 'trash', action: () => MapService.removeElement(this.element) }
      ]
    }
  },
  computed: {
    color () {
      return this.active ? '#FF0000' : '#333333'
    },

    latlngs () {
      return this.element.locations.map(x => [ x.lat, x.lng ])
    },
  },

  methods: {
    click (event) {
      this.$emit('click', event)
    },

    contextmenu (event) {
      this.$emit('menu', {event: event, data: this.menu})
    },

    async edit () {
      const result = await this.$dialog.showAndWait(ElementDialog, { element: this.element, actions: { 'false': 'No', 'true': 'Yes' } })

      if (result)
        this.$emit('save', { assetId: this.element.assetId })
    },
  },

  watch: {
    active (value) {
      if (this.editable && !value) {
        this.editable = false
        this.$emit('save', { locations: this.$refs.element.mapObject._latlngs })
      }
    },

    editable (value) {
      const editor = this.$refs.element.mapObject.enableEdit()

      if (value)
        editor.enable()
      else
        editor.disable()
    }
  },

  components: {
    LPolyline
  }
}
</script>
